export const BASIC_MISSION_LIST_REQUEST = 'BASIC_MISSION_LIST_REQUEST';

export const BASIC_MISSION_CREATE_REQUEST = 'BASIC_MISSION_CREATE_REQUEST';

export const BASIC_MISSION_INFO_DETAIL_REQUEST = 'BASIC_MISSION_INFO_DETAIL_REQUEST';

export const BASIC_MISSION_INFO_UPDATE_REQUEST = 'BASIC_MISSION_INFO_UPDATE_REQUEST';

export const BASIC_MISSION_INFO_REMOVE_REQUEST = 'BASIC_MISSION_INFO_REMOVE_REQUEST';

export const BASIC_MISSION_INFO_DEPOSIT_REQUEST = 'BASIC_MISSION_INFO_DEPOSIT_REQUEST';

export const BASIC_MISSION_INFO_ADD_BUDGET_REQUEST = 'BASIC_MISSION_INFO_ADD_BUDGET_REQUEST';

export const BASIC_REFERRAL_ACCOUNT_INFO_LIST_REQUEST = 'BASIC_REFERRAL_ACCOUNT_INFO_LIST_REQUEST';

export const BASIC_REFERRAL_INVITED_USER_LIST_REQUEST = 'BASIC_REFERRAL_INVITED_USER_LIST_REQUEST';

export const BASIC_REFERRAL_GRADE_REWARD_LOG_LIST_REQUEST = 'BASIC_REFERRAL_GRADE_REWARD_LOG_LIST_REQUEST';

export const BASIC_REFERRAL_POINT_LOG_LIST_REQUEST = 'BASIC_REFERRAL_POINT_LOG_LIST_REQUEST';

